const CREDENTIAL_STATUS = {
  ACTIVE: 'Active',
  REVOKED: 'Revoked',
  REVOKING: 'Revoking',
};

export default CREDENTIAL_STATUS;
